import { IdValue } from '../../../../../shared/models/id-value.model';

export enum IncomeFrequencyType {
  NotAssigned = 0,
  Yearly = 1,
  Monthly = 2,
  SemiMonthly = 3,
  BiWeekly = 4,
  Weekly = 5,
  Hourly = 6,
  Variable = 7,
  Other = 8,
}

export const incomeFrequencyOptions: IdValue<number, number, string>[] = [
  new IdValue(IncomeFrequencyType.NotAssigned, IncomeFrequencyType.NotAssigned, 'Select Frequency'),
  new IdValue(IncomeFrequencyType.Yearly, IncomeFrequencyType.Yearly, 'Yearly'),
  new IdValue(IncomeFrequencyType.Monthly, IncomeFrequencyType.Monthly, 'Monthly'),
  new IdValue(IncomeFrequencyType.SemiMonthly, IncomeFrequencyType.SemiMonthly, 'Semi-Monthly'),
  new IdValue(IncomeFrequencyType.BiWeekly, IncomeFrequencyType.BiWeekly, 'Bi-Weekly'),
  new IdValue(IncomeFrequencyType.Weekly, IncomeFrequencyType.Weekly, 'Weekly'),
  new IdValue(IncomeFrequencyType.Hourly, IncomeFrequencyType.Hourly, 'Hourly'),
  new IdValue(IncomeFrequencyType.Variable, IncomeFrequencyType.Variable, 'Variable'),
  new IdValue(IncomeFrequencyType.Other, IncomeFrequencyType.Other, 'Other'),
];
